/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class EventCreationTimeRangeQueryOperator extends models.ThreatVulnerabilityDateRangeQueryOperator {
    constructor() {
        super();
        this.setDiscriminator("EventCreationTimeRangeQueryOperator");
    }

    getFixupPrototypeFunction() { return EventCreationTimeRangeQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<EventCreationTimeRangeQueryOperator>): EventCreationTimeRangeQueryOperator {
        let obj = Object.assign(new EventCreationTimeRangeQueryOperator(), model);
        EventCreationTimeRangeQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<EventCreationTimeRangeQueryOperator>): EventCreationTimeRangeQueryOperator {
        if (!model) return null;
        return EventCreationTimeRangeQueryOperator.newInstance(<EventCreationTimeRangeQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: EventCreationTimeRangeQueryOperator) {
        if (!obj) return;

        models.EventCreationTimeRangeQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: EventCreationTimeRangeQueryOperator): boolean {
        if (models.ThreatVulnerabilityDateRangeQueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, EventCreationTimeRangeQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
